import React, { useCallback, useEffect, useMemo } from "react";
import { useObservable } from "micro-observables";

import { Select } from "../../../../../../components/Inputs/Select/Select";
import {
    blockSelectors,
    currentBlockSelector,
    setCurrentBlockSelector
} from "../../services/stepThree";

import styles from "./styles.module.scss";

const HeaderCommands = () => {
    const blockSelectorList = useObservable(blockSelectors);
    const blockSelector = useObservable(currentBlockSelector);

    const filteredBlockSelectorList = useMemo(
        () => blockSelectorList.filter(({ type_code, source_code }) => (
            source_code === "HTTP_RESPONSE_BODY" && type_code === "NONE"
        )),
        [ blockSelectorList ]
    );

    const options = useMemo(
        () => filteredBlockSelectorList.map(({ name }) => ({
            value: name,
            label: name
        })),
        [ filteredBlockSelectorList ]
    );

    const handleChange = useCallback(
        (value) => {
            const selector = filteredBlockSelectorList.find(({ code }) => code === value);

            if(selector) {
                setCurrentBlockSelector(selector);
            }
        },
        [ filteredBlockSelectorList ]
    );

    useEffect(
        () => {
            if(
                blockSelector.data_selectors.length === 0 &&
                filteredBlockSelectorList[0] &&
                filteredBlockSelectorList[0]?.data_selectors.length !== 0
            ) {
                setCurrentBlockSelector(filteredBlockSelectorList[0]);
            }
        },
        [ filteredBlockSelectorList, blockSelector, options ]
    );

    if(options.length === 0) {
        return null;
    }

    return (
        <div className={styles.headerCommands} >
            <Select
                hideHelpText
                options={options}
                value={options[0].value}
                onChange={handleChange}
            />
        </div>
    );
};

export default HeaderCommands;
